import Login from './components/Login';

const LoginPage = () => {
  return (
    <div className="my-40 flex flex-col items-center justify-center">
      <Login />
    </div>
  );
};

export default LoginPage;
